import { createRouter, createWebHashHistory } from 'vue-router'
import { setMenu, setModuleMenu } from '@/utils/permission'

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login')
  },
  {
    path: '/:pathMatch(.*)*',
    hide: true,
    component: () => import('@/views/404'),
  },
  {
    path: '/module',
    name: 'Module',
    component: () => import('@/views/module')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 白名单页面
const whiteList = ['/login']; // 可根据需要添加更多无需登录的页面

router.beforeEach(async (to, from, next) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    // 已登录，继续原有逻辑
    if(!router.options.routes[0].children && to.path !== "/login"){
      setMenu();  //生成所有菜单
      if(sessionStorage.getItem('moduleMenuIds')){ setModuleMenu() }  //如果有模块id，渲染模块菜单
      next({
        path: to.path,
        query: to.query,
        replace: true
      });
    }else{
      next()
    }
  } else {
    // 未登录
    if (whiteList.includes(to.path)) {
      next(); // 白名单内，放行
    } else {
      next('/login'); // 非白名单，跳转登录
    }
  }
})


export default router
